// import { ScadenzaAdapter } from './scadenza-adapter';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ProveScritteFormComponent } from '../../../form/prove-scritte/prove-scritte-form.component';


import { ProvaScritta } from '../../../models/prova-scritta';
import { SezioneProveScritte } from '../../../models/sezioni/sezione-prove-scritte';

@Component({
    selector: 'div [prova-scritta-form-update]',
  templateUrl: '../../../form/prove-scritte/prove-scritte-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ProvaScrittaUpdateConcreteFormComponent extends ProveScritteFormComponent implements OnInit {

  idSezione: string;
  provaScritta: ProvaScritta;
  urlUpdate: string;

  @Output()
  onReturn: EventEmitter<SezioneProveScritte> = new EventEmitter<SezioneProveScritte>();

  constructor( @Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica dati - Prova scritta');
    this.populateSelect();
    this.isInserimento(false);
  }

  getProvaScritta() {
    return this.provaScritta;
  }

  getRequest(request: ProvaScritta) {
    this.operationService.updateProvaScritta(this.urlUpdate, request, this.idSezione).subscribe(response => this.sezioneProveScritteUpdated(response));
  }

  sezioneProveScritteUpdated(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(url: string, provaScritta: ProvaScritta, idSezione: string) {
    this.urlUpdate = url;
    this.provaScritta = provaScritta;
    this.idSezione = idSezione;
    this.createForm();
  }
}
